import { signedTl } from "../lib/api";

export function DiffBadge({ diff, testId = "discrepancy-badge" }) {
  if (diff == null)
    return (
      <span data-testid={testId} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500">
        Sayım yapılmadı
      </span>
    );
  const cls =
    diff < 0
      ? "bg-rose-100 text-rose-700 ring-rose-300"
      : diff > 0
      ? "bg-emerald-100 text-emerald-700 ring-emerald-300"
      : "bg-slate-100 text-slate-700 ring-slate-300";
  const label = diff < 0 ? "Kasa Açığı" : diff > 0 ? "Kasa Fazlası" : "Kasa Dengede";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold ring-1 ${cls}`}>
      {label}
      {diff !== 0 && <span className="font-mono">{signedTl(diff)}</span>}
    </span>
  );
}
